import type { RootState } from '@/root-store';

import { namespace } from '../namespace';

const getEarnings = (state: RootState) => state[namespace].earnings;
const getInterval = (state: RootState) => state[namespace].interval;

export { getEarnings, getInterval };
